export const accountsPath = '/';

const encodeSegment = (value: string): string => encodeURIComponent(value);

export const environmentPath = (environment: string): string =>
  `/${encodeSegment(environment)}`;

export const channelsPath = (environment: string, accountId: string): string =>
  `${environmentPath(environment)}/${encodeSegment(accountId)}`;

export const channelPath = (
  environment: string,
  accountId: string,
  channelId: string,
): string =>
  `${channelsPath(environment, accountId)}/${encodeSegment(channelId)}`;

export const appSearchFromSearch = (search: string): string => {
  const params = new URLSearchParams(search);
  params.delete('accountId');
  params.delete('channelId');
  params.delete('channelSlug');
  params.delete('env');
  const nextSearch = params.toString();
  return nextSearch ? `?${nextSearch}` : '';
};

export const legacyPathFromSearch = (search: string): string | null => {
  const params = new URLSearchParams(search);
  const accountId = params.get('accountId');
  const channelId = params.get('channelId') || params.get('channelSlug');
  const environment = params.get('env') || 'dev';

  if (!accountId) return null;

  const path = channelId
    ? channelPath(environment, accountId, channelId)
    : channelsPath(environment, accountId);
  return `${path}${appSearchFromSearch(search)}`;
};
